/**
 * Redimensiona/comprime imagem no browser para envio no chat (máx ~350KB).
 */
export async function compressImageFile(file, { maxSide = 1280, maxBytes = 340 * 1024 } = {}) {
  if (!file || !String(file.type || '').startsWith('image/')) {
    throw new Error('Arquivo precisa ser uma imagem');
  }

  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
  const w = Math.max(1, Math.round(bitmap.width * scale));
  const h = Math.max(1, Math.round(bitmap.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(bitmap, 0, 0, w, h);
  if (bitmap.close) bitmap.close();

  let quality = 0.82;
  let blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  while (blob.size > maxBytes && quality > 0.45) {
    quality -= 0.08;
    blob = await canvasToBlob(canvas, 'image/jpeg', quality);
  }
  if (blob.size > maxBytes) {
    throw new Error('Imagem muito grande mesmo após comprimir (máx. 350 KB)');
  }

  const dataUrl = await blobToDataUrl(blob);
  const base64 = dataUrl.split(',')[1] || '';
  return {
    mime: 'image/jpeg',
    data: base64,
    name: String(file.name || 'comprovante')
      .replace(/\.[^.]+$/, '')
      .slice(0, 60) || 'comprovante',
    size: blob.size,
    dataUrl,
  };
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error('Falha ao comprimir imagem'))),
      type,
      quality
    );
  });
}

function blobToDataUrl(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('Falha ao ler imagem'));
    reader.readAsDataURL(blob);
  });
}
